import { HOME_ENDPOINTS } from '../constants/apiConstants'
import { retryAsyncFunction } from './retryAsyncFunction'

let letterId = 0
let letterName = ''

const uploadFile = async (axios, fileData) => {
    let formData = new FormData()
    formData.append('FileName', fileData.file.name)
    formData.append('FileContentType', fileData.file.type)
    formData.append('FileSize', fileData.file.size)
    formData.append('FileData', fileData.file)
    formData.append('AppId', fileData.appId)
    formData.append('ESignedDateTime', new Date().toJSON())
    formData.append('LetterId', fileData.letterId)

    return retryAsyncFunction(
        async () =>
            await axios
                .post(HOME_ENDPOINTS.UPLOAD, formData)
                .then((response) => {
                    return response
                }),
        3,
        (err) => {
            throw new Error(err)
        }
    )
}

const downloadFile = async (axios, id, setLoadingData) => {
    const config = {
        params: {
            letterId: id,
        },
    }

    setLoadingData(true)
    const resp = await axios
        .get(HOME_ENDPOINTS.DOWNLOADLETTER, config)
        .then((res) => {
            const b64toBlob = (b64Data, contentType = '', sliceSize = 1) => {
                const byteCharacters = atob(b64Data)
                const byteArrays = []
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArrays.push(byteCharacters.charCodeAt(i))
                }
                return byteArrays
            }
            var byteArray = b64toBlob(res.data.data, 'application/pdf')
            var byteArr = new Uint8Array(byteArray)
            setLoadingData(false)
            return { name: res.data.fileName, data: byteArr }
            // saveByteArray(letterName, byteArr);
        })
        .catch((error) => {
            setLoadingData(false)
            return null
            // console.log(error)
        })

    return resp
}

const saveByteArray = (reportName, byte) => {
    var blob = new Blob([byte], { type: 'application/pdf' })
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    var fileName = reportName
    link.download = fileName
    link.click()
}

export { uploadFile, downloadFile, saveByteArray }
